export default {
    data() {
        return {
            defaultBackgroundColor: "#19a98f",
            defaultBackgroundShape: require("@assets/img/book-insights/bi-bg-placeholder.png")
        }
    },
    computed: {
        $_backgroundColor() {
            return this.bookInsight.background.color ? this.bookInsight.background.color : this.defaultBackgroundColor
        },
        $_backgroundShape() {
            return this.bookInsight.background.shape
                ? this.bookInsight.background.shape : this.defaultBackgroundShape;
        }
    }
}
